import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/fi.ts
var add = "Lisää";
var remove = "Poista";
var removeAll = "Poista kaikki";
var incomplete = "Kaikkia kenttiä ei ole täytetty oikein.";
var submit = "Tallenna";
var noFiles = "Ei valittuja tiedostoja";
var moveUp = "Siirrä ylös";
var moveDown = "Siirrä alas";
var isLoading = "Ladataan...";
var loadMore = "Lataa lisää";
var next = "Seuraava";
var prev = "Edellinen";
var addAllValues = "Lisää kaikki arvot";
var addSelectedValues = "Lisää valitut arvot";
var removeAllValues = "Poista kaikki arvot";
var removeSelectedValues = "Poista valitut arvot";
var chooseDate = "Valitse päivämäärä";
var changeDate = "Vaihda päivämäärä";
var close = "Sulje";
var open = "Avoinna";
var accepted = function({
  name
}) {
  return `Ole hyvä ja hyväksy ${name}`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} tulee olla ${date(args[0])} jälkeen.`;
  }
  return `${sentence(name)} on oltava tulevaisuudessa.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} saa sisältää vain kirjaimia.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} saa sisältää vain kirjaimia ja numeroita.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} voivat sisältää vain kirjaimia ja välilyöntejä.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} on sisällettävä aakkoselliset merkit.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} täytyy sisältää kirjaimia tai numeroita.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} täytyy sisältää kirjaimia tai välilyöntejä.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} täytyy sisältää symboli.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} täytyy sisältää isoja kirjaimia.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} täytyy sisältää pieniä kirjaimia.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} täytyy sisältää numeroita.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} on oltava symboli.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} voi sisältää vain isoja kirjaimia.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} voi sisältää vain pieniä kirjaimia.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} tulee olla ennen: ${date(args[0])}.`;
  }
  return `${sentence(name)} on oltava menneisyydessä.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Tämä kenttä on täytetty virheellisesti joten sitä ei voitu lähettää.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} on oltava välillä ${a} - ${b} `;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} ei täsmää.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ei ole validi päivämäärä, ole hyvä ja syötä muodossa: ${args[0]}`;
  }
  return "Tämä kenttä on täytetty virheellisesti joten sitä ei voitu lähettää.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} on oltava välillä ${date(args[0])} - ${date(args[1])}`;
};
var email = "Syötä validi sähköpostiosoite.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} tulee päättyä ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} ei ole sallittu vaihtoehto.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} on oltava vähintään yksi merkki.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} on oltava ${max2} tai alle merkkiä.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} pitäisi olla ${max2} merkkiä pitkä.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} on oltava vähintään ${min2} merkkiä.`;
  }
  return `${sentence(name)} on oltava vähintään ${min2}, enintään ${max2} merkkiä.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} ei ole sallittu arvo.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Valitse enintään ${args[0]} ${name} vaihtoehtoa.`;
  }
  return `${sentence(name)} on oltava ${args[0]} tai alle.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Tiedostoja ei sallita.";
  }
  return `${sentence(name)} tulee olla ${args[0]}-tiedostotyyppiä.`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Valitse vähintään ${args[0]} ${name} vaihtoehtoa.`;
  }
  return `${sentence(name)} tulee olla ${args[0]} tai suurempi.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” ei ole sallittu ${name}.`;
};
var number = function({
  name
}) {
  return `Kentän ${sentence(name)} tulee olla numero.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" tai ")} vaaditaan.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} vaaditaan.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} on alettava ${list(args)}.`;
};
var url = function() {
  return `Anna kelvollinen URL-osoite.`;
};
var invalidDate = "Valittu päivämäärä on virheellinen.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var fi_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, fi_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=fi.mjs.map